import { motion } from "framer-motion";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-36 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C09D64]">
          (04) — Contact
        </p>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          data-testid="contact-heading"
          className="mt-6 font-serif text-5xl md:text-7xl lg:text-[7rem] leading-[0.95] text-white"
        >
          Let&rsquo;s talk.
          <br />
          <span className="italic text-zinc-400">Return your time.</span>
        </motion.h2>

        <div className="mt-14 md:mt-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-end">
          <div className="lg:col-span-6">
            <p className="text-zinc-400 text-base md:text-lg max-w-md leading-relaxed">
              For collaborations, AI builds, automation audits, or just a
              conversation about where medicine and machines are heading — the
              door is open.
            </p>
          </div>

          <div className="lg:col-span-6 flex flex-col gap-3">
            <a
              href="https://instagram.com/bintangbputra"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram-link"
              className="group flex items-center justify-between gap-4 border border-white/[0.1] rounded-full pl-6 pr-2 py-2.5 hover:bg-white hover:text-black transition-colors duration-300"
            >
              <span className="flex items-center gap-4">
                <Instagram className="w-4 h-4 text-zinc-400 group-hover:text-black transition-colors" />
                <span className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 group-hover:text-black/60">
                  Instagram
                </span>
                <span className="font-serif text-lg md:text-xl">
                  @bintangbputra
                </span>
              </span>
              <span className="w-9 h-9 rounded-full border border-white/15 group-hover:border-black/20 group-hover:bg-black group-hover:text-white inline-flex items-center justify-center transition-all">
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </a>

            <a
              href="mailto:bintang@bintangputra.dev"
              data-testid="contact-email-link"
              className="group flex items-center justify-between gap-4 border border-white/[0.1] rounded-full pl-6 pr-2 py-2.5 hover:bg-white hover:text-black transition-colors duration-300"
            >
              <span className="flex items-center gap-4">
                <Mail className="w-4 h-4 text-zinc-400 group-hover:text-black transition-colors" />
                <span className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 group-hover:text-black/60">
                  Email
                </span>
                <span className="font-serif text-lg md:text-xl">
                  bintang@bintangputra.dev
                </span>
              </span>
              <span className="w-9 h-9 rounded-full border border-white/15 group-hover:border-black/20 group-hover:bg-black group-hover:text-white inline-flex items-center justify-center transition-all">
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
